import { h, Component } from 'preact';
import {JavaScriptIcon, RailsIcon, BootstrapIcon, GithubIcon, HerokuIcon, CssIcon, HtmlIcon} from './../Icons'

export default class Achievr extends Component {
	render() {
		return (
      <section class="Content border">
        <div class="Container">
          <div class="Product">
            <div class="info">
              <div class="Title">
                <span class="text">Achievr, 2017</span>
              </div>
							<p>A minimal and clean implementation of a guided onboarding journey that allows new employees quick and easy integration into a new company.</p>
							<p><i>Le Wagon bootcamp project</i></p>
              <span style={{ width:'100%' }}>
								<RailsIcon />
								<JavaScriptIcon />
								<HtmlIcon />
								<CssIcon />
							</span>
              <a href="https://github.com/samcorin/hackernews-newtab-ext" class="Button">Source Code</a>
            </div>
            <div class="Image shadow border">
              <img src="https://firebasestorage.googleapis.com/v0/b/homepage-b9f4a.appspot.com/o/achievr-flat-min.png?alt=media&token=38fd69b3-9c29-4b2a-a182-5b7320780d1e" style={{ border: 'none', boxShadow: 'none' }} alt="Achievr" />
            </div>
          </div>
        </div>
      </section>
		);
	}
}



// WEBPACK FOOTER //
// ./components/achievr/index.js